import React from "react";
import { Html } from '@react-three/drei';
import { MoonLoader } from 'react-spinners';

export const LoaderProgress = () => {

  return (
    <>
      <Html center>
          <MoonLoader 
            speedMultiplier={0.3} 
            size={80}
            cssOverride={{
              marginBottom: '250px'
            }}
          />
      </Html>
    </>
  );
};

export default LoaderProgress;